export default __webpack_public_path__ + "static/media/T346_CoC.abfe2cd0.pdf";